import * as React from "react";
const SvgFiRrSuperscript = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-superscript_svg__a)">
      <path
        fill="#062147"
        d="M24 1v9a1 1 0 1 1-2 0V3.386l-.78.809a1 1 0 1 1-1.439-1.389l2.413-2.5a1 1 0 0 1 .72-.306C23.466 0 24 .447 24 1m-9.37 5.224a1 1 0 0 0-1.406.146L7.5 13.415 1.776 6.369A1.001 1.001 0 0 0 .224 7.63l5.987 7.369-5.987 7.37a1 1 0 1 0 1.552 1.262L7.5 16.586l5.724 7.045a.997.997 0 0 0 1.406.145 1 1 0 0 0 .146-1.407L8.79 15l5.987-7.369a1 1 0 0 0-.146-1.407"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-superscript_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSuperscript;
